import { render, staticRenderFns } from "./RiskCell.vue?vue&type=template&id=d94f99b8&scoped=true"
import script from "./RiskCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./RiskCell.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RiskCell.vue?vue&type=style&index=0&id=d94f99b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94f99b8",
  null
  
)

export default component.exports